

































































































































































import { computed, defineComponent, reactive, ref, watch, getCurrentInstance } from '@vue/composition-api';
import { SubmitContext } from 'tdesign-vue';
import { FileCopyIcon } from 'tdesign-icons-vue';
import { formHandler } from '@/renderer/views/desktop/ManageConsole/UIDesign/composition/formHandler';
import store from '@/renderer/store/index';
import { copyText2Clipboard, getOrgNameState } from '@/renderer/scripts/utils/tools/index';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import smh from '@/renderer/scripts/smh';
import { httpUrl, CONSTANT_URL } from '@/renderer/scripts/http';
import orgNameValidator from '@/renderer/views/desktop/ManageConsole/UIDesign/orgNameValidator';
import upgradeDialog from '@/renderer/scripts/utils/upgradeDialog';
import i18n, { i18n_t } from '@/locales/i18n';

export default defineComponent({
  components: {
    FileCopyIcon,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { $store } = context.root;
    const defaultOrgName = computed(() => $store.getters.orgName);
    const defaultShowOrgName = computed(() => $store.getters.showOrgName);
    const defaultOrgLogo = computed(() => $store.getters.orgLogo);
    const radioValue = ref('main');
    const formData = reactive({
      orgName: defaultOrgName.value,
      showOrgName: defaultShowOrgName.value,
    });
    const {
      logoInfo,
      files,
      orgLogo,
      uploadComp,
      uploading,
      fileSizeError,
      fileTypeError,
      selectedFile,
      resPath,
      methods: { beforeUpload, cancelUpload },
    } = formHandler().logoUploadHandler({
      // 考虑到有部分逻辑是需要自行处理的，且这里的逻辑只会执行一次,故直接内嵌函数
      afterUploadCOS: (
        tempLogoSrc: string,
        {
          name,
          size,
        }: {
          name: string;
          size: number;
        },
      ) => {
        tips.success(i18n_t('图片上传成功'));
      },
    });
    const orgNameValidate = computed(
      () => formData.orgName === '' || formData.orgName.length > ConstantConfig.orgNameMaxLength,
    );
    const hasLogo = ref(false);
    // 是否使用的是默认logo
    const isUsingDefaultLogo = computed(() => orgLogo.value === store.getters.defaultLogo);

    // 计算名称的长度
    const lengthState = computed(() => {
      const name = formData.orgName;
      return getOrgNameState(name, 'orgName');
    });
    const domain = computed(() => {
      const defaultDomain = `${$store.getters.protocol}://${CONSTANT_URL.currentDomain}`;
      const { domains } = $store.getters;
      if (domains.length === 0) {
        return defaultDomain;
      }
      return domains[0].domain;
    });
    const entId = computed(() => domain.value?.split('.')[0]);
    if (defaultOrgLogo.value) {
      hasLogo.value = true;
      const newImg = new Image();
      newImg.src = defaultOrgLogo.value;
      newImg.onload = () => {
        orgLogo.value = newImg.src;
      };
    }
    const submitBtnDisabled = computed(
      () =>
        (formData.orgName === defaultOrgName.value &&
          orgLogo.value === defaultOrgLogo.value &&
          formData.showOrgName === defaultShowOrgName.value) ||
        uploading.value ||
        orgNameValidate.value,
    );
    const { rules } = orgNameValidator(formData.orgName);
    const methods = {
      // 使用默认logo
      useDefaultLogo(e: Event) {
        e.stopPropagation();
        e.preventDefault();
        orgLogo.value = httpUrl.staticCDNURLMap.productLogoUrl;
        selectedFile.value = false;
      },
      submit({ validateResult, firstError }: SubmitContext<FormData>) {
        if (validateResult !== true) {
          tips.warning(firstError as string);
          return;
        }
        this.confirm();
      },
      async confirm() {
        if (formData.orgName !== defaultOrgName.value) {
          try {
            await smh.userAPI.updateOrgInfo({
              name: formData.orgName,
            });
            store.commit('SET_ORG_NAME', formData.orgName);
            tips.success(i18n_t('修改成功'));
          } catch (e) {
            tips.error(e as MsgError);
          }
        }
        if (formData.showOrgName !== defaultShowOrgName.value) {
          try {
            await smh.userAPI.updateOrgInfo({
              extensionData: {
                showOrgNameInUI: formData.showOrgName,
              },
            });
            store.commit('SET_SHOW_ORG_NAME', formData.showOrgName);
            tips.success(i18n_t('修改成功'));
          } catch (e) {
            tips.error(e as MsgError);
          }
        }
        if (orgLogo.value !== defaultOrgLogo.value) {
          try {
            let saveOrgLogo = '';
            if (isUsingDefaultLogo.value) {
              await smh.userAPI.postOrgLogo({
                filePath: '',
              });
              saveOrgLogo = httpUrl.staticCDNURLMap.productLogoUrl;
            } else {
              const res = await smh.userAPI.postOrgLogo({
                filePath: resPath.value,
              });
              saveOrgLogo = `${$store.getters.protocol}:${res.data.logo}`;
            }
            orgLogo.value = saveOrgLogo;
            store.commit('SET_ORG_LOGO', saveOrgLogo);
            tips.success(i18n_t('修改成功'));
            selectedFile.value = false;
          } catch (e) {
            tips.error(e as MsgError);
            orgLogo.value = httpUrl.staticCDNURLMap.productLogoUrl;
            selectedFile.value = false;
          }
        }
      },
      copyLink() {
        copyText2Clipboard(entId.value)
          .then(() => {
            tips.success(i18n_t('复制成功'));
          })
          .catch(() => {
            tips.success(i18n_t('复制失败'));
          });
      },
      // 团队版获取自定义域名
      getDomain() {
        upgradeDialog.show({
          source: 'unique_domain_name',
          header: i18n_t('暂无专属域名'),
          body: i18n_t('当前版本暂无专属域名，升级企业版即可使用独属于您企业的专属域名'),
        });
      },
    };
    watch(defaultOrgName, (val: string) => {
      formData.orgName = val;
    });
    watch(defaultShowOrgName, (val: boolean) => {
      formData.showOrgName = val;
    });
    watch(defaultOrgLogo, (val: string, old: string) => {
      if (!old && val) {
        hasLogo.value = true;
        const newImg = new Image();
        newImg.src = defaultOrgLogo.value;
        newImg.onload = () => {
          orgLogo.value = newImg.src;
        };
      }
      orgLogo.value = val;
    });
    return {
      domain,
      entId,
      ConstantConfig,
      formData,
      orgLogo,
      isUsingDefaultLogo,
      rules,
      orgNameValidate,
      fileTypeError,
      fileSizeError,
      files,
      logoInfo,
      hasLogo,
      selectedFile,
      beforeUpload,
      cancelUpload,
      submitBtnDisabled,
      uploadComp,
      radioValue,
      lengthState,
      ...methods,
    };
  },
});
